import z from 'zod';
import { pricePositiveSchema, quantitySchema } from '../../validation';

/**
 * Volume / revenue forecast (or actual rollup) for a single `Route`.
 *
 * The network model has no broker margin baked into the route, so this is a
 * single neutral amount — broker margin is computed per-leg at read time from
 * `Order.contracts[i]`.
 */
export const routeOrdersSchema = z.object({
  /** the number of orders to be generated on a monthly basis on this route */
  monthlyOrdersCount: quantitySchema,

  /**
   * the total sales amount on this route's orders in a month.
   * **BEFORE TAX & FEES**.
   */
  monthlyAmount: pricePositiveSchema,
});
